import React from "react";
import { connect } from "react-redux";
import { Marker, LayerGroup } from "react-leaflet";
import { MarkerIcon, createCustomIcon } from "./Icons";
import _ from "lodash";
import { selectMarker } from "redux/actions/index";
import { LazyMapTooltip } from "../util/LazyTooltips";
import MlAssetMarker from "./MlAssetMarker";
import { getKonuxStatusFromHealthValue } from "components/assets/KonuxAssetTab";
import moment from "moment";

const customMarkerDict = {};

class AssetMarkers extends React.PureComponent {
    iconClick = (marker) => {
        if (this.props.interactive) {
            this.props.dispatch(selectMarker(marker));
        }
    };

    extractExtraFields = (asset) => {
        const fields = {};
        if (asset.asset_type === "Konux Sensor") {
            const data = JSON.parse(asset.data);

            const healthDisplacementData = _.get(data, ["KONUX_HEALTH"], {});

            const health = _.get(healthDisplacementData, ["health"]);
            const displacement = _.get(healthDisplacementData, ["displacement"]);
            const timestamp = _.get(healthDisplacementData, ["timestamp"]);

            fields["Health"] = getKonuxStatusFromHealthValue(health).value;
            fields["Displacement"] = `${Math.round(displacement * 100) / 100}mm`;
            fields["Data Updated"] = moment(timestamp * 1000).fromNow();
        }

        return fields;
    };

    renderMarkerTooltip = (asset, onlyKeysToDisplay = null) => {
        if (!asset?.data) return null;

        const assetData = JSON.parse(asset.data);
        let allData = _.merge(assetData, this.extractExtraFields(asset));

        // if onlyKeysToDisplay is provided, filter the data to include only those keys
        if (onlyKeysToDisplay) {
            _.forEach(allData, (value, key) => {
                if (!onlyKeysToDisplay.includes(String(key).toLocaleLowerCase())) {
                    delete allData[key];
                }
            });
        }

        // sort markerInfo to have Name as first field and leave rest as is
        allData = Object.fromEntries(
            Object.entries(allData).sort((a, b) => {
                if (String(a[0]).toLocaleLowerCase() === "name") return -1;
                if (String(b[0]).toLocaleLowerCase() === "name") return 1;
                return 0;
            }),
        );

        const fields = _.map(allData, (value, key) => {
            if (value && value !== "null" && value !== "Unknown" && typeof key === "string" && typeof value === "string") {
                if (!["_", "~"].includes(key.charAt(0))) {
                    return (
                        <tr key={key}>
                            <td className={"Key"}>{_.startCase(key)}:</td>
                            <td className={"Value"}>{value}</td>
                        </tr>
                    );
                }
            }
        });
        const extraDataPanel = (
            <table className={"MarkerTooltipAdditionalInfo"}>
                <tbody>{fields}</tbody>
            </table>
        );

        return <div className={`MarkerTooltipOuter ${this.props.stripped === "ole_patrols" ? "FitContent" : ""}`}>{extraDataPanel}</div>;
    };

    renderAsset = (asset) => {
        if (this.props.assetSearch.mlAsset) {
            return (
                <MlAssetMarker
                    asset={asset}
                    displayingAsNearby={true}
                />
            );
        }
        let markerIconToUse = MarkerIcon;

        if (asset) {
            const selected = asset === this.props.selectedMarker;

            if (asset.icon_name) {
                let cacheIconName = asset.icon_name + asset.icon_colour + (selected ? "_selected" : "");
                if (!(cacheIconName in customMarkerDict)) {
                    customMarkerDict[cacheIconName] = createCustomIcon(asset.icon_name, asset.icon_colour, selected);
                }

                markerIconToUse = customMarkerDict[cacheIconName];
            }
        }

        let onlyKeysToDisplay = null;

        if (this.props.stripped === "ole_patrols") {
            onlyKeysToDisplay = ["elr", "trid", "miles", "yards", "name"];
        }

        return (
            <Marker
                onClick={() => (this.props.customMarkerOnClickAction ? this.props.customMarkerOnClickAction(asset) : this.iconClick(asset))}
                key={"Marker" + asset.asset_id}
                position={[asset.lat, asset.lon]}
                icon={markerIconToUse}>
                <LazyMapTooltip
                    className="Incident-Tooltip"
                    permanent={false}
                    interactive={true}
                    direction={"top"}
                    offset={[0, -30]}>
                    {this.renderMarkerTooltip(asset, onlyKeysToDisplay)}
                </LazyMapTooltip>
            </Marker>
        );
    };

    render() {
        let assets = this.props.assets;

        return <LayerGroup>{assets.map(this.renderAsset)}</LayerGroup>;
    }
}

const mapStateToProps = (state) => {
    return {
        assets: state.assets.assetsFound,
        assetTypes: state.assets.assetTypes,
        isStills: state.playlist.position.isStills,
        selectedMarker: state.markers.selectedMarker,
        assetSearch: state.assets.assetSearch,
    };
};

export default connect(mapStateToProps)(AssetMarkers);
